import {
  ComplianceDocumentStatus,
  ComplianceEventType,
  ComplianceOcrStatus,
} from '../../../types/api';
import { COMPLIANCE_TYPE_DEFINITIONS } from './spec';

const STATUS_LABELS: Record<ComplianceDocumentStatus, string> = {
  draft: 'Borrador',
  active: 'Activo',
  expired: 'Vencido',
  archived: 'Archivado',
};

export const getComplianceStatusLabel = (
  status: ComplianceDocumentStatus,
): string => STATUS_LABELS[status];

export const formatComplianceTypeLabel = (typeKey: string): string => {
  if (!typeKey) {
    return '';
  }

  const definition = COMPLIANCE_TYPE_DEFINITIONS.find(
    (item) => item.key === typeKey,
  );
  if (definition) {
    return definition.label;
  }

  return typeKey
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const EVENT_LABELS: Record<ComplianceEventType, string> = {
  created: 'Creado',
  uploaded: 'Archivo cargado',
  status_changed: 'Estado actualizado',
  reminder_sent: 'Recordatorio enviado',
  downloaded: 'Descargado',
  deleted: 'Eliminado',
  ocr_started: 'OCR iniciado',
  ocr_succeeded: 'OCR completado',
  ocr_failed: 'OCR fallido',
};

export const getComplianceEventLabel = (
  eventType: ComplianceEventType,
): string => EVENT_LABELS[eventType];

const OCR_STATUS_LABELS: Record<ComplianceOcrStatus, string> = {
  pending: 'Pendiente',
  succeeded: 'Completado',
  failed: 'Fallido',
};

export const getComplianceOcrStatusLabel = (
  status: ComplianceOcrStatus | null,
): string => {
  if (!status) {
    return '—';
  }
  return OCR_STATUS_LABELS[status];
};
